import { localDataFormat, localMonthFormat } from '../../../../constants/apiDateFormat';
import { getMiddleDate, getFormattedDate } from '../../../../utils/dateUtils';
import { GraphGroupBy } from '../../interfaces/GraphGroupBy';

const dateFormatConfig: Record<GraphGroupBy, string> = {
  DAY: localDataFormat,
  WEEK: localDataFormat,
  MONTH: localMonthFormat,
};

export const getLabelForPeriod = (
  startDate: string,
  endDate: string,
  groupBy: GraphGroupBy,
) => {
  const middleDate = getMiddleDate(startDate, endDate);

  switch (groupBy) {
    case 'DAY':
      return getFormattedDate(middleDate, dateFormatConfig[groupBy]);
    case 'WEEK':
      return `${getFormattedDate(startDate, dateFormatConfig[groupBy])} - ${getFormattedDate(endDate, dateFormatConfig[groupBy])}`;
    case 'MONTH':
      return getFormattedDate(middleDate, localMonthFormat);
  }
};
